import { Conduit } from '@aligned-solutions/conduit';
import { authentication } from '../../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}booking/ski/pass/`,
  [],
  [authentication],
  [],
  false,
  30000,
  true,
);

export default {
  /**
   * @param bookingId
   * @returns {AxiosPromise}
   */
  getSkiPassByBookingId(bookingId) {
    return conduit.get(`booking/${bookingId}/all`);
  },

  /**
   * @param bookingParticipantId
   * @param skiPass
   * @returns {AxiosPromise}
   */
  createSkiPass(bookingParticipantId, skiPass) {
    return conduit.post(`booking-participant/${bookingParticipantId}/create`, { skiPass });
  },

  /**
   * @param skiPass
   * @returns {AxiosPromise}
   */
  updateSkiPass(skiPass) {
    return conduit.put(`${skiPass.id}/update`, { skiPass });
  },

  /**
   * @param skiPassPrice
   * @returns {AxiosPromise}
   */
  updateSkiPassPrice(skiPassPrice) {
    return conduit.put(`${skiPassPrice.id}/update-price`, { skiPassPrice });
  },

  /**
   * @param skiPassCancellationFeeNet
   * @returns {AxiosPromise}
   */
  updateSkiPassCancellationFeeNet(skiPassId, cancellationFeeNet) {
    return conduit.put(`${skiPassId}/cancellation-fee-net`, { cancellationFeeNet });
  },

  /**
   * @param skiPassId
   * @param supplierRef
   * @returns {AxiosPromise}
   */
  updateSkiPassWithSupplierRef(skiPassId, supplierRef) {
    return conduit.put(`${skiPassId}/supplier-ref`, { supplierRef });
  },

  /**
   * @param skiPassId
   * @returns {AxiosPromise}
   */
  reOpen(skiPassId) {
    return conduit.put(`${skiPassId}/reopen`);
  },

  /**
   * @param skiPassId
   * @param salesAgentUserId
   * @returns {AxiosPromise}
   */
  cancelSkiPass(skiPassId, salesAgentUserId) {
    return conduit.delete(`${skiPassId}/sales-agent/${salesAgentUserId}/cancel`);
  },

  /**
   * @param skiPassId
   * @param salesAgentUserId
   * @returns {AxiosPromise}
   */
  stopSkiPass(skiPassId, salesAgentUserId) {
    return conduit.delete(`${skiPassId}/sales-agent/${salesAgentUserId}/stop`);
  },

  /**
   * @param skiPassId
   * @param salesAgentUserId
   * @returns {AxiosPromise}
   */
  deleteSkiPass(skiPassId, salesAgentUserId) {
    return conduit.delete(`${skiPassId}/sales-agent/${salesAgentUserId}/delete`);
  },

  /**
   * @param bookingId
   * @returns {AxiosPromise}
   */
  sendSkiPassRequestEmail(bookingId) {
    return conduit.post('send-supplier-request', { bookingId });
  },

  /**
   * @param payload
   * @returns {AxiosPromise}
   */
  assignParticipantToSkiPass(payload) {
    return conduit.put('assign-participant', payload);
  },

  /**
   * @param payload
   * @returns {AxiosPromise}
   */
  bookByXML(payload) {
    return conduit.post('book-by-xml', payload);
  },
};



// WEBPACK FOOTER //
// ./src/services/ski/booking-ski-pass-service.js